import { IProfile } from '../index'
import { IObjectData } from '../request/response'

export default function(item: IObjectData): IProfile {
  return {
    accountNumber: item.account_number,
    city: item.city,
    companyCity: item.company_city,
    companyCountry: Number(item.company_country),
    companyName: item.company_name,
    companyPostCode: item.company_post_code,
    companyStreet: item.company_street,
    companyVatNumber: item.company_vat_number,
    email: item.email,
    facebook: item.facebook,
    id: Number(item.id),
    idCountry: Number(item.country),
    idCurrency: Number(item.id_currency),
    logoUrl: item.logo_url,
    name: item.name,
    phone: item.phone,
    postCode: item.post_code,
    pricelistVersion: item.pricelist_version,
    street: item.street,
    swift: item.swift,
    type: Number(item.type),
    www: item.www,
  }
}
